import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getPerformance, FirebasePerformance } from 'firebase/performance';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// 🔧 FIX: Use persistent single-tab cache for both dev and prod
// - persistentSingleTabManager() is more stable than persistentMultipleTabManager()
// - forceOwnership: false prevents tab conflicts and "INTERNAL ASSERTION FAILED" errors
//
// Bug fixed: persistentMultipleTabManager() caused "Unexpected state" errors in Firestore 10.14.1
// Solution: Use single-tab manager with non-forced ownership in all environments
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager({
      forceOwnership: false
    })
  })
});

// Initialize Firebase services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

// Connect to emulators in development (deshabilitado temporalmente)
// if (import.meta.env.DEV) {
//   console.log('🔧 Conectando a emuladores de Firebase...');
//   connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
//   connectFirestoreEmulator(db, '127.0.0.1', 8080);
//   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
//   connectStorageEmulator(storage, '127.0.0.1', 9199);
//   console.log('✅ Conectado a emuladores locales');
// }

// Initialize Analytics (only in browser, not in SSR)
let analyticsInstance: Analytics | null = null;
let perfInstance: FirebasePerformance | null = null;

if (typeof window !== 'undefined') {
  try {
    analyticsInstance = getAnalytics(app);
    perfInstance = getPerformance(app);
  } catch (error) {
    console.warn('Analytics/Performance not available:', error);
  }
}

export const analytics = analyticsInstance;
export const perf = perfInstance;

// Expose db globally for debugging (remove in production)
if (typeof window !== 'undefined') {
  (window as any).__FIREBASE_DB__ = db;
}
